import styled, { css } from 'styled-components';
import { Link as LinkComponent } from 'react-router-dom';
import { layout, media, styledUtils } from '@prisjakt/ui-base';
import SotyBadgeComponent from '../soty-badge-link/soty-badge';

const sharedStyles = css`
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  position: relative;
  outline: none;
  padding: ${layout.productCardPaddingSmall};
  ${media.mediumUp`
    padding: ${layout.productCardPaddingLarge};
  `}

  &::before {
    ${styledUtils.overlay()};
  }
`;

export const Content = styled.div`
  ${sharedStyles};
`;

export const Link = styled(LinkComponent)`
  ${sharedStyles};

  @media (pointer: fine) {
    &:hover::after,
    &.focus-visible::after {
      ${styledUtils.overlay()}
    }
  }
`;

export const Card = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-self: stretch;
  width: 100%;
  min-height: 100%;
  min-width: ${layout.productCardMinWidthMobile};
  max-width: ${layout.productCardMaxWidth};
  text-align: center;
`;

export const Title = styled.span`
  font-weight: 600;
`;

export const Subtitle = styled.span(
  props => css`
    font-size: ${layout.measurements.fontSizeSmall};
    color: ${props.theme.text.tertiary};
    font-weight: 600;
  `
);

const sharedImageStyling = css`
  margin-bottom: ${layout.measurements.spacing100};
`;

export const SotyBadge = styled(SotyBadgeComponent)`
  ${sharedImageStyling};
`;

export const Image = styled.div`
  ${sharedImageStyling};
  display: flex;
  justify-content: center;
`;

export const ImageWrapper = styled.div`
  width: 88px;
`;
